import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import 'shared/styles/table.style.less';
import {Button} from 'antd';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import OrganizationTable from './OrganizationTable';
import {OrganizationContext} from './OrganizationContext';
import {IoReload} from 'react-icons/all';

const OrganizationList = () => {
  const intl = useIntl();
  const organizationContext = useContext(OrganizationContext);

  const {setReloading} = organizationContext;

  return (
    <>
      <AppPageMetadata title={intl.messages['organization.list']} />
      <AppsContainer
        title={intl.messages['organization.list']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view' />
            <div className='customer-header-right'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoReload />}
                onClick={() => setReloading(true)}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <OrganizationTable />
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default OrganizationList;
